import type { ReactElement } from "react";

import type { TableActionProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import ContactsExportDropdownContainer from "app/pages/sales-intelligence/sub-modules/contacts-search/containers/ExportVariantsDropdown";
import { useContactSearchResult } from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactSearchResult";

import ContactsExportPanelContainer from "../ContactsExportPanel/ContactsExportPanelContainer";

const ContactsExportVariantsDropdownContainer = (props: TableActionProps): ReactElement => {
    const { data, isFetching } = useContactSearchResult();

    const numberOfResults = data?.totalCount || 0;

    function handlePanelActivate() {
        props.onActivate(() => ContactsExportPanelContainer);
    }

    return (
        <ContactsExportDropdownContainer
            isLoading={isFetching}
            numberOfResults={numberOfResults}
            onActivate={handlePanelActivate}
        />
    );
};

export default ContactsExportVariantsDropdownContainer;
